import { ModuleRole } from './moduleRole';
import { RolAccess } from './rolAccess';
import { Injectable } from "@angular/core";

export interface Role {
    role?: string;
    access?: RolAccess[];
    id: string;
    nit: string;
    name: string;
    modules?: ModuleRole[];
    notificationTypes?: Array<string>;
}


@Injectable()
export class RoleModel {
    public model = {
        nit: '',
        id: '',
        name: '',
    };
}
